import { Box, Typography } from "@mui/material";

import CoachingImage from "@app/analytics/assets/Coaching.png";
import ROUTES from "@app/common/routes";

import Button from "@rui/Button";
import {
  EmptyStateContainer,
  EmptyStateSubtext,
} from "@rui/EmptyStateContainer";
import { Link } from "@rui/Link";

const UnlockCoaching = () => (
  <EmptyStateContainer variant="center" spacing={2}>
    <Box
      component="img"
      src={CoachingImage}
      sx={{ height: "100%", maxHeight: "180px" }}
    />
    <Typography variant="bodyPrimaryMed">
      Unlock your Coaching trends!
    </Typography>
    <EmptyStateSubtext>
      Have a meeting with Read to see customized coaching for clarity,
      inclusion, and impact across all of your meetings.
    </EmptyStateSubtext>
    <Link to={ROUTES.CALENDAR}>
      <Button>Add Read to a meeting</Button>
    </Link>
  </EmptyStateContainer>
);

export default UnlockCoaching;
